import { withStyles } from "@material-ui/core/styles";
import Footer from "./Footer";
import styles from "./styles";
import withPrograma from "js/hoc/withPrograma";

import { compose } from "recompose";

const enhance = compose(
  withPrograma,
  withStyles(styles)
);
export default enhance(Footer);
